<template>
  <tr>
    <td>
      <div class="items-wrapper d-flex align-items-center pl-2">
        {{ user.first_name }} {{ user.last_name }}
      </div>
    </td>
    <td nowrap>
      <div>
        <popper
          trigger="hover"
          :options="{
            placement: 'top',
            modifiers: { offset: { offset: '0,10px' } },
          }"
        >
          <div class="popper">
            {{ user.email }}
          </div>
          <div slot="reference">
            <div class="text-truncate">
              <a v-if="user.email" :href="`mailto:${user.email}`" class="mr-3" target="_top">{{
                user.email
              }}</a>
            </div>
          </div>
        </popper>
      </div>
    </td>
    <td class="">{{ user.phone || 'N/A' }}</td>
    <td>{{ user.email_notifications ? 'Enabled' : 'Disabled' }}</td>
    <td>{{ user.format_date }}</td>
    <td>{{ user.timezone_data.utc_timezone }}</td>
    <td>{{ userCodeMixin(user.type).type }}</td>
    <td>
      {{
        user.privacy_date
          | formatDate({
            format: getUserProfile.format_date,
            timezone: getUserProfile.timezone,
            hasHourAndMinutes: false,
          })
      }}
    </td>
    <td>
      <div class="icon-wrapper d-flex" style="justify-content:end">
        <a @click="editUser" data-toggle="modal" :href="`#editUserModal-${user.profile_id}`"
          ><svgHelper class="mr-3 edit" name="edit"></svgHelper
        ></a>
        <a data-toggle="modal" :href="`#deleteUserModal-${user.profile_id}`"
          ><svgHelper class="mr-3" name="delete"></svgHelper
        ></a>
      </div>
    </td>
    <td align="center">
      <div>
        <button :disabled="isSending" @click="resetPassword" class="btn btn-danger btn-sm">
          Reset
        </button>
      </div>

      <!-- Edit Modal -->
      <div
        class="modal fade edit-modal"
        :id="`editUserModal-${user.profile_id}`"
        tabindex="-1"
        aria-labelledby="editUserModal"
        aria-hidden="true"
        data-backdrop="static"
      >
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
            <form ref="saveform" @submit.prevent="saveFormChanges">
              <div class="modal-header">
                <h5 class="modal-title" id="editUserModalLabel">Edit User</h5>
                <button
                  type="button"
                  class="close"
                  data-dismiss="modal"
                  aria-label="Close"
                  ref="closeModal"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>

              <div class="modal-body">
                <div class="d-flex align-items-center">
                  <div class="form-group flex-grow-1 mr-2">
                    <div class="form-group m-label-left isWidth">
                      <input
                        v-model="selectedUserFirstName"
                        id="name"
                        type="text"
                        class="form-control"
                        placeholder="Name"
                      />
                      <label for="name">First name</label>
                    </div>

                    <div class="form-group m-label-left isWidth">
                      <input
                        v-model="selectedUserLastName"
                        id="name"
                        type="text"
                        class="form-control"
                        placeholder="Name"
                      />
                      <label for="name">Last name</label>
                    </div>

                    <div class="form-group m-label-left isWidth">
                      <input
                        id="email"
                        type="email"
                        v-model="selectedUserEmail"
                        class="form-control mt-2"
                        placeholder="Email"
                        disabled
                      />
                      <label for="email">Email</label>
                    </div>
                    <div class="row">
                      <div class="form-group m-label col-md-5 country-code-user no-hor">
                        <v-select
                          id="country-code"
                          style="font-size: 14px; height: 42px"
                          @input="addCountryCodeEdit(selectedCountryCode)"
                          v-model="selectedCountryCode"
                          :options="
                            [...getAllCountries].map(item => `${item.phone_code} ${item.name}`)
                          "
                          :clearable="false"
                        >
                          <template v-slot:option="option">
                            {{ option.label }}
                          </template>
                        </v-select>
                        <label for="country-code">Country Code</label>
                      </div>
                      <div class="form-group m-label col-md-7">
                        <input
                          id="phone"
                          type="text"
                          class="form-control"
                          v-model="selectedUserPhone"
                        />
                        <label for="phone">Phone</label>
                      </div>
                    </div>
                    <div class="form-group m-label-left isWidth">
                      <select
                        v-model="selectedNotification"
                        id="user-type"
                        class="has-floating-label form-select mt-2"
                      >
                        <option value="true">Yes</option>
                        <option value="false">No</option>
                      </select>
                      <label for="user-type">Email Notifications</label>
                    </div>
                    <div class="form-group m-label-left isWidth">
                      <select id="format_date" class="form-select" v-model="selectedDateFormat">
                        <option>YY-MM-DD</option>
                        <option>YY/MM/DD</option>
                        <option>DD-MM-YY</option>
                        <option>DD/MM/YY</option>
                        <option>MM-DD-YY</option>
                        <option>MM/DD/YY</option>
                      </select>
                      <label for="format_date">Format Date</label>
                    </div>

                    <div class="form-group m-label-left country-code-user">
                      <v-select
                        ref="tzSelect"
                        placeholder="Select Timezone"
                        v-model="selectedUserTimeZone"
                        :options="tzOptions"
                        :clearable="false"
                        :reduce="zone => zone"
                        :filterable="false"
                        label="utc_timezone"
                        @search="onTzSearch"
                        @open="onTzOpen"
                      >
                        <template #option="{ utc_timezone }">
                          {{ utc_timezone }}
                        </template>
                        <template #selected-option="{ utc_timezone }">
                          {{ utc_timezone }}
                        </template>
                      </v-select>
                      <label for="role">Time Zone</label>
                    </div>

                    <div class="form-group m-label-left isWidth">
                      <select
                        v-model="selectedUserRole"
                        id="user-type"
                        class="has-floating-label form-select mt-2"
                      >
                        <option value="2">Manager</option>
                        <option value="1">User</option>
                      </select>
                      <label for="user-type">User Role</label>
                    </div>
                  </div>
                </div>
              </div>
              <div class="modal-footer text-center justify-content-center">
                <button type="submit" class="btn btn-primary">
                  Save changes
                </button>

                <button type="button" class="btn btn-secondary" data-dismiss="modal">
                  Cancel
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      <!-- Delete Modal -->
      <div
        class="modal fade edit-modal"
        :id="`deleteUserModal-${user.profile_id}`"
        tabindex="-1"
        aria-labelledby="deleteUserModal"
        aria-hidden="true"
        data-backdrop="static"
      >
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="deleteUserModalLabel">Delete User</h5>
              <button
                @click="closeModal"
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
                ref="closeButton"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>

            <div class="modal-body text-center justify-content-center">
              <p>
                Please confirm that you want to delete {{ user.first_name }} {{ user.last_name }}
              </p>
            </div>
            <div class="modal-footer text-center justify-content-center">
              <button @click="deleteUser" type="button" class="btn btn-primary">Confirm</button>

              <button
                @click="closeModal"
                type="button"
                class="btn btn-secondary"
                data-dismiss="modal"
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
      <!-- END MODALS -->
    </td>
  </tr>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { accountTypeMixin } from '../../../mixins/accountTypeMixin';
import { TIME_ZONES } from '../../../constants';
import axios from 'axios';
export default {
  mixins: [accountTypeMixin],
  props: {
    user: Object,
  },
  data() {
    return {
      selectedUserFirstName: '',
      selectedUserLastName: '',
      selectedCountryCode: '',
      selectedUserPhone: '',
      selectedNotification: false,
      selectedUserEmail: '',
      selectedDateFormat: '',
      selectedUserRole: '',
      selectedUserTimeZone: '',
      closeModal: false,
      isSending: false,
      timeZonePreview: '',
      timeZone: '',
      tzOptions: [],
      tzPage: 1,
      tzLastPage: 1,
      tzSearch: '',
      tzLoading: false,
      tzSearchTimeout: null,
    };
  },
  methods: {
    ...mapActions(['updateUserForEmployer']),

    fetchTimezones(reset = false) {
      if (this.tzLoading) return;
      if (!reset && this.tzPage > this.tzLastPage) return;
      this.tzLoading = true;
      if (reset) {
        this.tzPage = 1;
        this.tzLastPage = 1;
      }
      axios(`${process.env.VUE_APP_API_URL}/common/timezone/all`, {
        method: 'post',
        data: { page: this.tzPage, count: 50, search_word: this.tzSearch },
        headers: {
          Authorization: `Bearer ${localStorage.getItem(
            `${process.env.VUE_APP_TOKEN_PREFIX}token`,
          )}`,
          Accept: 'application/json',
        },
      })
        .then(res => {
          const raw = res.data.data !== undefined ? res.data.data : res.data;
          const items = Array.isArray(raw) ? raw : Object.values(raw);
          if (reset) {
            this.tzOptions = items;
          } else {
            const dropdown = this.$refs.tzSelect.$refs.dropdownMenu;
            const scrollTop = dropdown ? dropdown.scrollTop : 0;
            items.forEach(item => this.tzOptions.push(item));
            this.$nextTick(() => {
              if (dropdown) dropdown.scrollTop = scrollTop;
            });
          }
          this.tzLastPage = res.data.last_page;
          this.tzPage += 1;
        })
        .catch(() => {})
        .finally(() => {
          this.tzLoading = false;
        });
    },
    onTzSearch(search) {
      clearTimeout(this.tzSearchTimeout);
      this.tzSearchTimeout = setTimeout(() => {
        this.tzSearch = search;
        this.fetchTimezones(true);
      }, 300);
    },
    onTzOpen() {
      this.$nextTick(() => {
        const dropdown = this.$refs.tzSelect.$refs.dropdownMenu;
        if (!dropdown) return;
        dropdown.addEventListener('scroll', this.onTzScroll);
      });
    },
    onTzScroll(e) {
      const el = e.target;
      if (this.tzPage > this.tzLastPage) return;
      if (this.tzLoading) return;
      if (el.scrollTop + el.clientHeight >= el.scrollHeight - 20) {
        this.fetchTimezones();
      }
    },
    addCountryCodeEdit(code) {
      this.selectedCountryCode = code.replace(/[0-9+]/g, '');
      this.selectedUserPhone = code.substring(0, code.indexOf(' ')) + ' ';
    },
    editUser() {
      this.fetchTimezones(true);
      if (this.user.phone !== null) {
        let extractedNumbers = this.user.phone.match(/^(\+\d+)\s/);
        if (extractedNumbers) {
          let countryCode = extractedNumbers[1]; // Extracted numbers before the space
          let exists = this.getAllCountries.find(country => country.phone_code === countryCode);

          if (exists) {
            this.selectedCountryCode = exists.name;
          } else {
            this.selectedCountryCode = '';
          }
        }
      }
      this.selectedUserFirstName = this.user.first_name;
      this.selectedUserLastName = this.user.last_name;
      this.selectedNotification = this.user.email_notifications;
      this.selectedDateFormat = this.user.format_date;
      this.selectedUserPhone = this.user.phone;
      this.selectedUserRole = this.user.type;
      this.selectedUserEmail = this.user.email;
      this.selectedUserTimeZone = {
        id: this.user.timezone_data.id,
        time_zone: this.user.timezone_data.time_zone,
        utc_timezone: this.user.timezone_data.utc_timezone,
      };
    },
    deleteUser() {
      axios
        .get(
          `${process.env.VUE_APP_API_URL}/admin/employer/deleteuserforemployer/${this.user.profile_id}`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem(
                `${process.env.VUE_APP_TOKEN_PREFIX}token`,
              )}`,
              'Content-Type': 'application/json',
              Accept: 'application/json',
            },
          },
        )
        .then(() => {
          this.$emit('change');
          this.$refs.closeButton.click();
        });
    },
    saveFormChanges() {
      let notification = true;
      if (this.selectedNotification === 'false') {
        notification = false;
      }
      this.updateUserForEmployer({
        profile_id: this.user.profile_id,
        first_name: this.selectedUserFirstName,
        last_name: this.selectedUserLastName,
        email_notifications: notification,
        phone_number: this.selectedUserPhone,
        format_date: this.selectedDateFormat,
        timezone_id: this.selectedUserTimeZone.id,
        user_type: this.selectedUserRole,
      })
        .then(() => {
          this.$emit('change');
          this.$refs.closeModal.click();
          this.$toasted.success('User updated.', {
            theme: 'bubble',
            icon: 'fa-times-circle',
            position: 'bottom-right',
            duration: 3000,
          });
        })
        .catch(err => {
          /*        console.log(err); */
        });
    },
    resetPassword() {
      this.isSending = true;
      axios(`${process.env.VUE_APP_API_URL}/auth/forgotpassword`, {
        method: 'post',
        data: {
          email: this.user.email,
        },
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      })
        .then(() => {
          this.isSending = false;
          this.$toasted.success('Email for password reset has been sent', {
            theme: 'bubble',
            icon: 'fa-times-circle',
            position: 'bottom-right',
            duration: 3000,
          });
        })
        .catch(() => {
          this.isSending = false;
          this.$toasted.error('Failed to reset password', {
            theme: 'bubble',
            icon: 'fa-times-circle',
            position: 'bottom-right',
            duration: 3000,
          });
        });
    },
  },
  computed: {
    ...mapGetters(['getAllCountries', 'getUserProfile']),
    getTimeZones() {
      return TIME_ZONES;
    },
  },
  mounted() {},
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/_variables.scss';

.modal-body {
  .form-control,
  .form-select {
    padding-left: 18px !important;
  }
}

.edit {
  fill: #a7a7a7;
}
</style>
